import { useIsMutating } from '@tanstack/react-query';
export function useIsReorderingContent() {
    const isReorderingModule = useIsMutating({ mutationKey: ['reorderModule'] });
    const isReorderingPage = useIsMutating({ mutationKey: ['reorderPage'] });
    return Boolean(isReorderingModule || isReorderingPage);
}
